import { Subject } from "rxjs";

const DealerLocationTabSubject = new Subject();

const DealerLocationService = {
  listen: () => DealerLocationTabSubject.asObservable(),
  suggestDealersFor: (message) => {
    if (message && message.latitude && message.longitude) {
      DealerLocationTabSubject.next(message);
    }
  },
};

export default DealerLocationService;
